/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from './include/left/left.component.ngfactory';
import * as i2 from '../../app/include/left/left.component';
import * as i3 from '@angular/router';
import * as i4 from '../../app/jwt/jwt.service';
import * as i5 from '../../app/common/api/user.service';
import * as i6 from './include/header/header.component.ngfactory';
import * as i7 from '../../app/include/header/header.component';
import * as i8 from './include/footer/footer.component.ngfactory';
import * as i9 from '../../app/include/footer/footer.component';
import * as i10 from '../../app/app.component';
const styles_AppComponent:any[] = ([] as any[]);
export const RenderType_AppComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,styles:styles_AppComponent,
    data:{}});
export function View_AppComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'app-left',([] as any[]),
      (null as any),(null as any),(null as any),i1.View_LeftComponent_0,i1.RenderType_LeftComponent)),
      i0.ɵdid(1,49152,(null as any),0,i2.LeftComponent,[i3.Router,i4.JwtService,i5.UserService],
          (null as any),(null as any)),(_l()(),i0.ɵted(-1,(null as any),['\n'])),(_l()(),
          i0.ɵeld(3,0,(null as any),(null as any),1,'app-header',([] as any[]),(null as any),
              (null as any),(null as any),i6.View_HeaderComponent_0,i6.RenderType_HeaderComponent)),
      i0.ɵdid(4,114688,(null as any),0,i7.HeaderComponent,[i3.Router,i5.UserService,
          i4.JwtService],(null as any),(null as any)),(_l()(),i0.ɵted(-1,(null as any),
          ['\n\n'])),(_l()(),i0.ɵeld(6,0,(null as any),(null as any),4,'main',[['role',
          'main']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted(-1,(null as any),['\n  '])),(_l()(),i0.ɵeld(8,16777216,(null as any),
          (null as any),1,'router-outlet',([] as any[]),(null as any),(null as any),
          (null as any),(null as any),(null as any))),i0.ɵdid(9,212992,(null as any),
          0,i3.RouterOutlet,[i3.ChildrenOutletContexts,i0.ViewContainerRef,i0.ComponentFactoryResolver,
              [8,(null as any)],i0.ChangeDetectorRef],(null as any),(null as any)),
      (_l()(),i0.ɵted(-1,(null as any),['\n'])),(_l()(),i0.ɵted(-1,(null as any),['\n'])),
      (_l()(),i0.ɵeld(12,0,(null as any),(null as any),1,'app-footer',([] as any[]),
          (null as any),(null as any),(null as any),i8.View_FooterComponent_0,i8.RenderType_FooterComponent)),
      i0.ɵdid(13,114688,(null as any),0,i9.FooterComponent,[i3.Router],(null as any),
          (null as any)),(_l()(),i0.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    _ck(_v,4,0);
    _ck(_v,9,0);
    _ck(_v,13,0);
  },(null as any));
}
export function View_AppComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'my-app',([] as any[]),
      (null as any),(null as any),(null as any),View_AppComponent_0,RenderType_AppComponent)),
      i0.ɵdid(1,49152,(null as any),0,i10.AppComponent,([] as any[]),(null as any),
          (null as any))],(null as any),(null as any));
}
export const AppComponentNgFactory:i0.ComponentFactory<i10.AppComponent> = i0.ɵccf('my-app',
    i10.AppComponent,View_AppComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvZ2l0bGFiLXJ1bm5lci9idWlsZHMvZDkwYzViY2YvMC9nYWlhL2dhaWEtdWktYW5ndWxhci9zcmMvYXBwL2FwcC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9naXRsYWItcnVubmVyL2J1aWxkcy9kOTBjNWJjZi8wL2dhaWEvZ2FpYS11aS1hbmd1bGFyL3NyYy9hcHAvYXBwLmNvbXBvbmVudC50cyIsIm5nOi8vL2hvbWUvZ2l0bGFiLXJ1bm5lci9idWlsZHMvZDkwYzViY2YvMC9nYWlhL2dhaWEtdWktYW5ndWxhci9zcmMvYXBwL2FwcC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvZ2l0bGFiLXJ1bm5lci9idWlsZHMvZDkwYzViY2YvMC9nYWlhL2dhaWEtdWktYW5ndWxhci9zcmMvYXBwL2FwcC5jb21wb25lbnQudHMuQXBwQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGFwcC1sZWZ0PjwvYXBwLWxlZnQ+XG48YXBwLWhlYWRlcj48L2FwcC1oZWFkZXI+XG5cbjxtYWluIHJvbGU9XCJtYWluXCI+XG4gIDxyb3V0ZXItb3V0bGV0Pjwvcm91dGVyLW91dGxldD5cbjwvbWFpbj5cbjxhcHAtZm9vdGVyPjwvYXBwLWZvb3Rlcj5cbiIsIjxteS1hcHA+PC9teS1hcHA+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTthQUFBO1VBQUEsNkJBQXFCLDBDQUNyQjtpQkFBQTtjQUFBO2FBQUE7dUJBQUEsK0JBQXlCO1VBQUEsV0FFekI7VUFBQTtNQUFrQiw0Q0FDaEI7VUFBQTtVQUFBLG1EQUFBO1VBQUE7Y0FBQTtNQUErQiwwQ0FDMUI7TUFDUDtVQUFBO2FBQUE7VUFBQSxlQUF5QjtJQUx6QjtJQUdFO0lBRUY7Ozs7b0JDTkE7TUFBQTthQUFBO1VBQUE7OzsifQ==



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/$$_gendir/app/app.component.ngfactory.ts